import { useTranslation } from "react-i18next"; // src/components/SubscriptionLocked.jsx
import React, { useState } from 'react';
import { RiLock2Line, RiMoneyDollarCircleLine, RiCustomerService2Line } from 'react-icons/ri';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const SubscriptionLocked = ({ currentStatus }) => {const { t } = useTranslation();
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [requested, setRequested] = useState(false);

  const handleRequestCashPayment = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/subscriptions/pay/cash', {
        billingCycle: 'monthly'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRequested(true);
      setMessage('Your request has been submitted. An admin will review it shortly.');
    } catch (error) {
      console.error('Payment request failed:', error);
      setMessage('Failed to submit request. Please try again or contact support.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
            <div className="bg-white p-8 rounded-xl shadow-2xl max-w-lg w-full text-center">
                <div className="inline-flex justify-center items-center w-20 h-20 bg-red-100 rounded-full mb-6">
                    <RiLock2Line className="text-4xl text-red-600" />
                </div>

                <h1 className="text-3xl font-bold text-gray-900 mb-2">{t("subscription_locked")}</h1>
                <p className="text-gray-600 mb-8">
                    {t("your_subscription_status_is")} <strong>{currentStatus.toUpperCase()}</strong>{t("please_renew_your_subscription_to_contin")}
                
        </p>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8 text-left">
                    <h3 className="font-semibold text-blue-800 mb-2 flex items-center">
                        <RiMoneyDollarCircleLine className="mr-2" /> {t("payment_options")}
                    </h3>
                    <p className="text-sm text-blue-700 mb-3">
                        {t("please_contact_the_administrator_to_proc")}
                    </p>

                    {!requested ?
          <a
            href="mailto:support@quadcores.com"
            className="block w-full text-center py-2 bg-blue-600 hover:bg-blue-700 text-white rounded font-medium transition-colors">
                            {t("contact_admin_to_renew")}
                        
          </a> :

          <div className="text-green-600 font-medium text-center bg-green-50 p-2 rounded">
                            {t("request_sent_pending_approval")}
                        </div>
          }
                    {message && !requested && <p className="text-red-500 text-sm mt-2">{message}</p>}
                </div>

                <div className="border-t pt-6">
                    <p className="text-sm text-gray-500 mb-4">{t("need_help_contact_support_at_support_qua")}</p>
                    <button
            onClick={logout}
            className="text-gray-500 hover:text-gray-700 font-medium">
                        {t("sign_out")}
                    
          </button>
                </div>
            </div>
        </div>);

};

export default SubscriptionLocked;